import {css, html, LitElement} from 'lit';
import {customElement} from 'lit/decorators.js';

import '@shoelace-style/shoelace/dist/components/spinner/spinner.js';

@customElement('sp-spinner-overlay')
export class SpSpinnerOverlay extends LitElement {
    static styles =
        // language=CSS
        css`
        :host {
            position: absolute;
            top: 0;
            left: 0;
            display: grid;
            place-items: center;
            width: 100%;
            height: 100%;    
            overflow: hidden;
            container-type: inline-size;
        }
        .spinner-background {
            z-index: 0;
            position: absolute;
            top: 0;
            left: 0;
            background-color: grey;
            opacity: 0.5;
            width: 100%;
            height: 100%;
        }

        sl-spinner {
            --track-width: 0.5rem;
            font-size: 4rem;
            --speed: var(--sp-default-spinner-speed);
        }

        /* When the container is smaller than the spinner, shrink the spinner accordingly */
        @container (max-width: 5rem) {
            sl-spinner {
                --track-width: 10%;
                font-size: 70cqw;
            }
        }
    `;

    protected render() {
        return html`
          <sl-spinner part="spinner"></sl-spinner>
          <div class="spinner-background"></div>
    `;
    }
}
